import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MOBILE_SCREEN_UTILS } from '@monorepo/ui';
import { AiAnalyticsModalComponent } from '../common-components/ai-analytics-modal/ai-analytics-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ChatbotService {
  readonly #isMobileScreen = MOBILE_SCREEN_UTILS.isMobileScreen();
  constructor(private modalController: ModalController) {}

  async openAiAnalytics() {
    const aiAnalyticsModal = await this.modalController.create({
      component: AiAnalyticsModalComponent,
      componentProps: {},
      ...(this.#isMobileScreen ? {} : { cssClass: 'ai-analytics-modal' }),
    });
    await aiAnalyticsModal.present();
  }
}
